/* eslint-disable sort-keys */
import textStyles from "../constants/textStyles";

export default {
    Textarea: {
        baseStyle: {
            _active: { boxShadow: "none" },
            _focus: { boxShadow: "none" },
            _hover: { boxShadow: "none" },
        },
        sizes: {},
        variants: {
            default: {
                ...textStyles.p1,
                mb: "0",
                borderRadius: "5",
                px: "4",
                py: "3",
                border: "1px solid",
                borderColor: "secondary.100",
                fontWeight: "600",
                transition:
                    " border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                // _placeholder: { opacity: "0.3" },
                _hover: { borderColor: "secondary.200" },
                _focus: { borderColor: "primary.400", borderWidth:"2px", _hover: { borderColor: "primary.400" } },
                _active: { borderColor: "primary.400", borderWidth:"2px", _hover: { borderColor: "primary.400" } },       
                _disabled: { borderColor: "secondary.100", bgColor: "secondary.100", opacity: "0.7", _hover: { borderColor: "secondary.100" } }    
            }
        },
        defaultProps: {
            variant: "default",
        },
    }
};

